import { render, staticRenderFns } from "./SuccessBox.vue?vue&type=template&id=5ada8886&scoped=true&"
import script from "./SuccessBox.vue?vue&type=script&lang=js&"
export * from "./SuccessBox.vue?vue&type=script&lang=js&"
import style0 from "./SuccessBox.vue?vue&type=style&index=0&id=5ada8886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada8886",
  null
  
)

export default component.exports